export const ASSET_BASE_URL =
  import.meta.env.VITE_ASSET_BASE_URL ||
  "/storage";

export function assetUrl(path: string): string {
  const trimmed = path.replace(/^\/+/, "");
  return `${ASSET_BASE_URL}/${trimmed}`;
}
